export const sanitizeUrl = (url, to_delete) => {
    return url.replace(to_delete,'');
}